import LocalizedStrings from "react-localization";
import LocalText from "src/local";
const localizationStrings = new LocalizedStrings({
  ja: {
    btnSignUp: LocalText.screens.authLanding.btnSignUp,
    btnSignIn: LocalText.screens.authLanding.btnSignIn,
  },
});

export { localizationStrings };
